module.exports = __webpack_public_path__ + "static/media/5.b0f08cf3.png";